var map = {
	"./de/info-btn.png": "Qu2m",
	"./en/info-btn.png": "9VfT",
	"./es/info-btn.png": "D1We",
	"./fr/info-btn.png": "B19w",
	"./ja/info-btn.png": "UqUp",
	"./ko/info-btn.png": "W9PF",
	"./pt/info-btn.png": "Dp9O",
	"./ru/info-btn.png": "DH1x",
	"./tc/info-btn.png": "9AJV",
	"./th/info-btn.png": "XxJa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Zg1X";